import React, { useEffect, useState } from 'react';
import ApiService from '../services/ApiService';
import { formatDate } from '../utils/helper';
import { toast } from 'react-toastify';

const buildDefaultSlots = () => {
    const slots = [];
    for (let i = 9; i <= 18; i++) {
        const hour = i < 10 ? `0${i}` : `${i}`;
        slots.push(`${hour}:00`);
        slots.push(`${hour}:30`);
    }
    return slots;
};

const TimeSlotSelect = ({ value, onChange, branchId, date, apiPrefix, name = 'time', size = 'lg' }) => {
    const [slots, setSlots] = useState(buildDefaultSlots());
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!branchId || !date) {
            setSlots(buildDefaultSlots());
            return;
        }

        const fetchSlots = async () => {
            try {
                setLoading(true);
                const dateObj = new Date(date);
                dateObj.setMinutes(dateObj.getMinutes() - dateObj.getTimezoneOffset());
                const formattedDate = dateObj.toISOString().split('T')[0];
                
                const response = await ApiService.request({
                    method: 'GET',
                    url: '/public/available-times',
                    data: {
                        branch_id: branchId,
                        date: formattedDate,
                    },
                });
                if (response.data.status && response.data.data && Array.isArray(response.data.data.time_slots)) {
                    const available = response.data.data.time_slots;
                    setSlots(available.length > 0 ? available : buildDefaultSlots());
                } else {
                    setSlots(buildDefaultSlots());
                }
            } catch (error) {
                setSlots(buildDefaultSlots());
                toast.error(error.response?.data?.message || 'Failed to load available times');
            } finally {
                setLoading(false);
            }
        };

        fetchSlots();
    }, [branchId, date]);

    const handleChange = (e) => {
        if (onChange) {
            onChange(e.target.value);
        }
    };

    const selectClass = size === 'lg' ? 'form-select form-select-lg form-select-solid' : 'form-select form-select-solid';

    return (
        <select
            className={selectClass}
            name={name}
            value={value || ''}
            onChange={handleChange}
            disabled={!branchId || !date || loading}
            required
        >
            <option value="">
                {!branchId || !date ? 'Select branch and date first' : loading ? 'Loading times...' : 'Select Time'}
            </option>
            {slots.map((t) => (
                <option key={t} value={t}>
                    {t}
                </option>
            ))}
        </select>
    );
};

export default TimeSlotSelect;
